<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card pb-5">
          <!-- Section Title -->
          <div class="p-3 pb-0">
            <h4>{{ $t("settings") }}</h4>
            <p>{{ $t("choosePreferences") }}</p>
          </div>

          <!-- Dynamic Sections -->
          <div class="p-3">
            <div class="row">
              <!-- Language -->
              <div class="col-md-6 col-12 mb-3">
                <h5>{{ $t("language") }}</h5>
                <div class="form-check">
                  <input
                    type="radio"
                    class="form-check-input"
                    v-model="language"
                    value="pt"
                    id="pt"
                    @change="updateLanguage('pt')"
                  />
                  <label class="form-check-label" for="pt">{{ $t("portuguese") }}</label>
                </div>
                <div class="form-check">
                  <input
                    type="radio"
                    class="form-check-input"
                    v-model="language"
                    value="en"
                    id="en"
                    @change="updateLanguage('en')"
                  />
                  <label class="form-check-label" for="en">{{ $t("english") }}</label>
                </div>
              </div>

              <!-- Weight Unit -->
              <div class="col-md-6 col-12 mb-3">
                <h5>{{ $t("weightUnit") }}</h5>
                <div class="form-check">
                  <input
                    type="radio"
                    class="form-check-input"
                    v-model="weightUnit"
                    value="kg"
                    id="kg"
                    @change="updateWeightUnit('kg')"
                  />
                  <label class="form-check-label" for="kg">{{ $t("kilograms") }}</label>
                </div>
                <div class="form-check">
                  <input
                    type="radio"
                    class="form-check-input"
                    v-model="weightUnit"
                    value="lbs"
                    id="lbs"
                    @change="updateWeightUnit('lbs')"
                  />
                  <label class="form-check-label" for="lbs">{{ $t("pounds") }}</label>
                </div>
              </div>

              <!-- Height Unit -->
              <div class="col-md-6 col-12 mb-3">
                <h5>{{ $t("heightUnit") }}</h5>
                <div class="form-check">
                  <input
                    type="radio"
                    class="form-check-input"
                    v-model="heightUnit"
                    value="m"
                    id="m"
                    @change="updateHeightUnit('m')"
                  />
                  <label class="form-check-label" for="m">{{ $t("meters") }}</label>
                </div>
                <div class="form-check">
                  <input
                    type="radio"
                    class="form-check-input"
                    v-model="heightUnit"
                    value="in"
                    id="in"
                    @change="updateHeightUnit('in')"
                  />
                  <label class="form-check-label" for="in">{{ $t("inches") }}</label>
                </div>
              </div>
            </div>
          </div>

          <!-- Selected Preferences Status -->
          <div class="p-3 mt-4">
            <p>
              <strong>{{ $t("selectedLanguage") }}:</strong> {{ language === 'pt' ? $t("portuguese") : $t("english") }}
            </p>
            <p>
              <strong>{{ $t("selectedWeightUnit") }}:</strong>
              {{ weightUnit === 'kg' ? $t("kilograms") : $t("pounds") }}
            </p>
            <p>
              <strong>{{ $t("selectedHeightUnit") }}:</strong>
              {{ heightUnit === 'm' ? $t("meters") : $t("inches") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Configuracao',
  computed: {
    ...mapState(['language', 'weightUnit', 'heightUnit']),
  },
  methods: {
    ...mapActions(['updateLanguage', 'updateWeightUnit', 'updateHeightUnit']),
  },
}
</script>
